<template>
  <v-select
    id="user-search-form-status"
    v-model="innerValue"
    name="user-search-form-status"
    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
    multiple
    label="name"
    :options="items"
    :reduce="item => item.id"
    :placeholder="placeholder"
    autocomplete="chrome-off"
  />
</template>

<script>
import Category from '@nollaSdk/models/Category'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },
  $_veeValidate: {
    name() {
      return this.name
    },
    value() {
      return this.value
    },
  },
  props: {
    value: {
      type: [Array, String],
      default: () => [],
    },
    error: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      innerValue: this.value,
      items: [],
    }
  },
  watch: {
    innerValue() {
      this.$emit('input', this.innerValue)
    },
  },
  mounted() {
    this.findItems()
  },
  methods: {
    findItems() {
      Category.findAll('/user-status')
        .then(models => {
          this.items = models
        })
    },
  },
}
</script>
